import type { ReactNode } from "react";
import React from "react";
import type { ButtonProps } from "@material-ui/core";
import { Button } from "@material-ui/core";
import type { IconProp } from "@fortawesome/fontawesome-svg-core";
import type { FontAwesomeIconProps } from "@fortawesome/react-fontawesome";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

type ButtonWithIconProps = Omit<ButtonProps, "startIcon" | "endIcon"> & {
    startIcon?: IconProp;
    startIconProps?: Omit<FontAwesomeIconProps, "icon">;
    endIcon?: IconProp;
    endIconProps?: Omit<FontAwesomeIconProps, "icon">;
};

export const ButtonWithIcon = (props: ButtonWithIconProps) => {
    const { startIcon, startIconProps, endIcon, endIconProps, ...otherProps } = props;

    let startIconNode: ReactNode;
    let endIconNode: ReactNode;

    if (startIcon) {
        startIconNode = <FontAwesomeIcon icon={startIcon} fixedWidth {...startIconProps} />;
    }
    if (endIcon) {
        endIconNode = <FontAwesomeIcon icon={endIcon} fixedWidth {...endIconProps} />;
    }

    return (
        <Button {...otherProps} startIcon={startIconNode} endIcon={endIconNode}>
            {props.children}
        </Button>
    );
};
